<footer class="footer">
    <div class="site-footer">
        <div class="inner-container">
             @if (footerData?.columnLinksCollection?.items?.length > 0) {
                <section class="sub-footer footer-links" >
                    <div class="footer-links-container">
                        @for (column of footerData?.columnLinksCollection?.items; track $index) {
                        <div class="columns" [class.active]="activeItem === column.cTitle" #columnElement>
                            <button (click)="openAccordion(column, columnElement)" [tabindex]="isDesktopUp ? -1 : 0">{{ column.cTitle }}
                                @if (activeItem === column.cTitle) {
                                    <i class="far fa-chevron-up"></i>
                                } @else {
                                    <i class="far fa-chevron-down"></i>
                                }
                            </button>
                            
                            <div class="link-container">
                                @for (link of column?.linksCollection?.items; track $index) {
                                    <lib-link  [externalLink]="link.externalLink" [internalLink]="link.internalLink?.url" [documentLink]="link.docLink" [linkTitle]="link.linkTitle" [childClass]="'footer-link' + (link.cssClass??'')" [target]="link.linkTarget"></lib-link>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    <hr class="line-break show-for-large">
                </section>
            }
            <section *ngIf="footerData?.footerLogo || footerData?.socialLinksCollection?.items?.length || footerData?.buttonLink1 || footerData?.buttonLink2"
                class="sub-footer footer-logo">
                <div class="subfooter-container grid-container">
                    <div class="image">
                        <img [src]="footerData?.footerLogo?.url" class="footer-logo" loading="lazy"
                            [alt]="footerData?.footerLogo?.description">
                    </div>
                    <div class="tagline">
                        <lib-contentful-rich-text *ngIf="footerData?.tagLine as tagLine"
                            [document]="tagLine"></lib-contentful-rich-text>
                    </div>
                    <!-- Social Links -->
                    <div class="social-icons" *ngIf="footerData?.socialLinksCollection?.items?.length">
                        <ng-container *ngFor="let socialLink of footerData?.socialLinksCollection.items">
                            <a [href]="socialLink.externalLink || socialLink.internalLink?.url" target="_blank"
                                [attr.aria-label]="socialLink.linkTitle">
                                <i class="fab" [class]="socialLink.cssClass"></i>
                            </a>
                        </ng-container>
                    </div>
                    <div class="buttons-container Black" *ngIf="footerData?.buttonLink1 || footerData?.buttonLink2">
                        <lib-link *ngIf="footerData?.buttonLink1 as buttonLink1" [childClass]="'btn secondary-button'"
                            [internalLink]="buttonLink1.internalLink?.url" [linkTitle]="buttonLink1.linkTitle"
                            [target]="buttonLink1.linkTarget" [externalLink]="buttonLink1.externalLink"
                            [documentLink]="buttonLink1.docLink" [fragment]="buttonLink1.jumpTarget"></lib-link>
        
                        <lib-link *ngIf="footerData?.buttonLink2 as buttonLink2" [childClass]="'btn primary-button'"
                            [internalLink]="applyNowUrl ? '' : buttonLink2.internalLink?.url" [linkTitle]="buttonLink2.linkTitle"
                            [target]="buttonLink2.linkTarget" [externalLink]="applyNowUrl || buttonLink2.externalLink"
                            [documentLink]="buttonLink2.docLink" [fragment]="buttonLink2.jumpTarget"></lib-link>
                    </div>
                </div>
            </section>
        </div>
        <div class="footer-copyright">
            <div class="footer-content grid-container">
                <div class="copy-right-container">
                    <lib-contentful-rich-text *ngIf="footerData?.copyright" [document]="footerData?.copyright" [richTextContentUnsafe]="true"></lib-contentful-rich-text>
                </div>
                <div class="links-container">
                    <ng-container *ngIf="footerData?.linksCollection?.items as footerLinks">
                        <lib-link *ngFor="let button of footerLinks" [childClass]="'footer-link'"
                            [internalLink]="button.internalLink?.url" [linkTitle]="button.linkTitle"
                            [target]="button.linkTarget" [externalLink]="button.externalLink"
                            [documentLink]="button.docLink" [fragment]="button.jumpTarget"></lib-link>
                    </ng-container>
                    <a *ngIf="footerData?.cookieLink" href="javascript:Optanon.ToggleInfoDisplay()" class="footer-link">Cookie Preferences</a>
                </div>
            </div>
        </div>
    </div>
</footer>
